







































































































































































import HeaderLayout from '@/layouts/nested/HeaderLayout.vue';
import { Component } from 'vue-property-decorator';
import Base from '../../Base';
import WHeaderBtn from '@/components/WHeaderBtn.vue';
import { DCPBranding, DCPConference, PastConference } from '@/models/DCPConference';
import DCPModeratorService from '@/service/DCPModeratorService';
import PinReservationService from '@/service/PinReservationService';
import { PinReservation } from '@/models/PinReservation';
import { createDCPConferenceDetailsXLSX, createEventLogXLSX } from '@/utils/excel';
import PresentationService from '@/service/PresentationService';
import { Presentation } from '@/models/Presentation';
import { enrichUserBasedData, transformToSessionBasedData } from '@/utils/conferenceDataTransformer';
import axios from 'axios';
import store from '@/store';

@Component({
  components: { HeaderLayout, WHeaderBtn }
})
export default class ModeratorDCP extends Base {

  title = 'Willkommen im neuen Interface';
  moderatorPIN = '';
  participantPIN = '';

  dcpWindow: Window | null = null;
  dcpUrl: string | undefined = process.env.VUE_APP_DCP_URL;

  currentConference: DCPConference | null = null;
  brandings: DCPBranding[] = [];
  selectedBranding: number | null = null;
  selectedPresentation: number | null = null;

  pinReservations: PinReservation[] = [];
  pastConferences: PastConference[] = [];
  presentations: Presentation[] = [];

  pastConferencesFields = [
    { key: 'title', label: 'Titel' },
    { key: 'startTime', label: 'Datum' },
    { key: 'durationSeconds', label: 'Dauer' },
    { key: 'participantCount', label: 'Teilnehmer' },
    { key: 'actions', label: 'Aktionen' }
  ];

  interval: number | null = null;

  mounted(): void {
    this.getConferences();
    this.getPinReservations();
    this.getBrandings();
    this.getPastConferences();
    this.getPresentations()

    this.interval = window.setInterval(() => {
      this.getConferences();
    }, 5000);

  }

  beforeDestroy(): void {
    if (this.interval) {
      window.clearInterval(this.interval);
    }
  }

  private getConferences() {
    console.log('mounted: get conferences');
    DCPModeratorService.getDCPConferences().then((obj) => {
      console.log('mounted: get conferences result ->', obj);
      if (obj.length > 0) {
        this.currentConference = obj[0];
      } else {
        this.currentConference = null;
      }
    });
  }

  private getBrandings() {
    DCPModeratorService.getDCPBrandings().then((brandings) => {
      this.brandings = brandings;
    }).catch(this.showNetworkError);
  }

  private getPinReservations() {
    PinReservationService.getReservations().then((reservations) => {
      if (reservations.length >= 2) {
        this.participantPIN = reservations[0].pin;
        this.moderatorPIN = reservations[1].pin;
      } else if (reservations.length === 1) {
        this.participantPIN = reservations[0].pin;
        this.moderatorPIN = Math.floor(Math.random() * 1000000).toString().padStart(6, '0');
      } else {
        this.participantPIN = Math.floor(Math.random() * 1000000).toString().padStart(6, '0');
        this.moderatorPIN = Math.floor(Math.random() * 1000000).toString().padStart(6, '0');
      }
      this.pinReservations = reservations;
    }).catch(this.showNetworkError);
  }

  private getPresentations() {
    PresentationService.getPresentations(0, 9999, 'dateUpdated', 'DESC').then((res) => {
      this.presentations = res.content.filter(p=>p.elementCount > 0);
      if(res.content.length > 0){
        this.selectedPresentation = res.content[0].id;
      }
    }).catch(this.showNetworkError);
  }

  submit(): void {
    console.log('submit', this.title, this.moderatorPIN, this.participantPIN);
    DCPModeratorService.startDCPConference({
      title: this.title,
      moderatorPIN: this.moderatorPIN,
      participantPIN: this.participantPIN,
      brandingId: this.selectedBranding,
      presentationId: this.selectedPresentation
    }).then((obj) => {
      if (obj) {
        this.currentConference = obj;
        this.openDCP()
      }
    }).catch(this.showNetworkError);
  }

  async stopDCP() {
    if (!this.currentConference) return;
    await DCPModeratorService.stopDCPConference(this.currentConference.id);
    this.currentConference = null;
    this.getConferences();
  }

  async openDCP(): Promise<void> {
    if (!this.currentConference) return;
    // const language = this.$i18n.locale;
    if (this.dcpUrl === undefined) {
      console.log('DCP_URL is not set');
      return;
    }
    if(this.dcpWindow){
      this.dcpWindow.close();
    }

    const conference = await DCPModeratorService.getDCPConference(this.currentConference.id);
    console.log("Moderator present?", conference.moderatorPresent);
    if(conference.moderatorPresent){
      const result = await this.$bvModal.msgBoxConfirm("Die Steuerung ist bereits in einem anderen Browser oder auf einem anderen PC aktiv. Möchten Sie die Steuerung trotzdem öffnen? Dann wird sie in der anderen Instanz geschlossen.", {
        title: 'Achtung',
        okVariant: 'danger',
        okTitle: 'Steuerung öffnen',
        cancelTitle: this.$t('common.cancel') as string,
        centered: true
      });
      if(!result){
        return;
      }
    }

    this.dcpWindow = window.open(`${this.dcpUrl}/${this.currentConference.moderatorPIN}?moderator=true&forceLogout=true`, '_blank');
    const interval = setInterval(() => {

      // if (this.dcpWindow && this.dcpWindow.location.origin === new URL(this.dcpUrl).origin)
      // console.log('this.dcpWindow.location.origin', this.dcpWindow?.location.origin);
      // console.log('new URL(this.dcpUrl).origin', new URL(this.dcpUrl || "").origin);


      if (this.dcpWindow && this.dcpUrl) {
        console.log('post connecting', this.dcpUrl);
        this.dcpWindow.postMessage('connecting', this.dcpUrl);
        // this.dcpWindow.postMessage('connecting', "http://localhost:5173/");
      }
    }, 1000);

    window.addEventListener('message', (event) => {
      console.log('event received', event.data);

      if (event.origin !== this.dcpUrl) return;
      if (event.data === 'connected') {
        console.log('Conference connected');
        clearInterval(interval);

        console.log('post token');
        if (this.dcpWindow) {
          this.dcpWindow.postMessage('authentication=' + JSON.stringify(this.$store.getters.authentication), this.dcpUrl);
          this.$store.commit('setLastActionTimestamp');
        }
      }
      if (event.data === 'disconnected') {
        console.log('Conference disconnected');
      }
    });
  }

  openParticipant(): void {
    if (!this.currentConference) return;
    // const language = this.$i18n.locale;
    if (this.dcpUrl === undefined) {
      console.log('DCP_URL is not set');
      return;
    }
    if(this.dcpWindow){
      this.dcpWindow.close();
    }
    this.dcpWindow = window.open(`${this.dcpUrl}/${this.currentConference.participantPIN}?username=MaxMustermann&forceLogout=true`, '_blank');
  }

  openCoModerator(): void {
    if (!this.currentConference) return;
    // const language = this.$i18n.locale;
    if (this.dcpUrl === undefined) {
      console.log('DCP_URL is not set');
      return;
    }
    if(this.dcpWindow){
      this.dcpWindow.close();
    }
    this.dcpWindow = window.open(`${this.dcpUrl}/${this.currentConference.moderatorPIN}?username=MaxMustermann&forceLogout=true`, '_blank');
  }

  private getPastConferences() {
    DCPModeratorService.getPastConferences().then((conferences) => {
      this.pastConferences = conferences.sort(
        (a, b) => new Date(b.startTime).getTime() - new Date(a.startTime).getTime()
      );
    }).catch(this.showNetworkError);
  }

  async exportConferenceDetailsUserBased(confId: string): Promise<void> {
    try {
      const conferenceDetails = await DCPModeratorService.getConferenceDetails(confId);
      const enrichedData = enrichUserBasedData(conferenceDetails);
      createDCPConferenceDetailsXLSX(enrichedData, this, 'user');
    } catch (error) {
      this.showNetworkError(error);
    }
  }

  async exportConferenceDetailsSessionBased(confId: string): Promise<void> {
    try {
      const conferenceDetails = await DCPModeratorService.getConferenceDetails(confId);
      const transformedData = transformToSessionBasedData(conferenceDetails);
      createDCPConferenceDetailsXLSX(transformedData, this, 'session');
    } catch (error) {
      this.showNetworkError(error);
    }
  }

  async exportEventLog(confId: string, conferenceTitle: string): Promise<void> {
    try {
      const eventLogs = await DCPModeratorService.getEventLogs(confId);
      createEventLogXLSX(eventLogs, conferenceTitle, this);
    } catch (error) {
      this.showNetworkError(error);
    }
  }

  async downloadMP4(confId: string): Promise<void> {
    window.open(`${axios.defaults.baseURL}/dcp/moderator/${confId}/record.mp4?access_token=${store.getters.accessToken}`, '_blank')
  }

  formatDate(date: Date): string {
    return new Date(date).toLocaleDateString('de-DE', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit'
    });
  }

  formatDuration(durationSeconds: number): string {
    const hours = Math.floor(durationSeconds / 3600);
    const minutes = Math.floor((durationSeconds % 3600) / 60);
    
    if (hours > 0) {
      return `${hours}h ${minutes}m`;
    } else {
      return `${minutes}m`;
    }
  }

}
